export const educations = [{
        city: "Malang, East Java",
        time: "Aug’2022 - Now",
        location: "Alterra Academy, React JS Front-End Engineer",
        description: "MBKM x Alterra Academy Bootcamp activity which focuses on learning Front End Engineer Using React JS",
    },
    {
        city: "Tanggerang, Banten",
        time: "Feb’2022 - July’2022",
        location: "Binar Academy, UI UX Research and Design",
        description: "Bootcame UI UX Designer with a focus on learning about design thinking, the design process from research to testing",
    },
    {
        city: "Bangkalan, East Java",
        time: "2019 - Now",
        location: "University of Trunojoyo Madura, S1 - Information System",
        description: "The disciplines studied are business management within the company, web, mobile and desktop application development as well as analyzing data and analyzing company business processes.",
    },
];